import { useSetAtom } from 'jotai'
import React from 'react'

import {
  StyledButton,
  type StyledButtonProps,
} from '~/components/elements/StyledButton'

import { dialogInfoAtom } from '../atoms'
import { type BrandAccountUser } from '../hooks'

type AddButtonProps = React.PropsWithChildren<{
  userRoleName: NonNullable<BrandAccountUser['role']>['name']
}>

export const AddButton = ({ children, userRoleName }: AddButtonProps) => {
  const setDialogInfo = useSetAtom(dialogInfoAtom)
  const handleAddButtonClick = React.useCallback<
    EH<StyledButtonProps, 'onClick'>
  >(() => {
    setDialogInfo({ dialogType: 'add', userRoleName })
  }, [userRoleName, setDialogInfo])

  return (
    <StyledButton
      buttonStyle="success"
      fillMode="outline"
      icon="add"
      onClick={handleAddButtonClick}
    >
      {children}
    </StyledButton>
  )
}
